import { Badge, Tooltip } from 'antd';
import './style.css';

export function BadgeOnOff({
    condition,
    onText,
    offText,
    status,
    text,
    tooltip,
}: {
    condition?: boolean;
    onText?: string;
    offText?: string;

    // OR //

    status?: 'success' | 'processing' | 'error' | 'default' | 'warning';
    text?: string;
    tooltip?: string;
}) {
    const badge = (
        <Badge
            status={status ? status : condition ? 'success' : 'error'}
            text={text ? text : condition ? onText : offText}
        />
    );

    if (tooltip) {
        return <Tooltip title={tooltip}>{badge}</Tooltip>;
    }

    return badge;
}
